import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { uploadData } from "aws-amplify/storage";
import { ActivityInterface } from 'src/app/models/activity.interface';
import { environment } from 'src/environments/environment';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ProgressComponent } from '../../common/progress/progress.component';

@Component({
    selector: 'app-activity-creation-page',
    templateUrl: './activity-creation-page.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./activity-creation-page.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: true,
    imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbModule,
    MatCardModule,
    ProgressComponent
]
})
export class ActivityCreationPageComponent implements OnInit {
  hoveredDate: NgbDate | null = null;

	fromDate: NgbDate;
	toDate: NgbDate | null = null;

  constructor(
    private formBuilder: FormBuilder,
    calendar: NgbCalendar
  ) {
    this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  @Input() storeId: string;
  activityId!: string;
  activity!: any;
  mapPoint: any;
  importantInfo: any;
  pictures: any[] = [];
  meetingPoint: any;
  importantInformations: any;
  amenities: any;
  includes: any;
  reviews!: string;
  mainActivityOptions: string[] = [];
  dateSelected: Date | null;

  createNewActivityAbout = this.formBuilder.group({
    activityName: ['', Validators.required],
    mainActivityType: new FormControl,
    activityDescription: ['', Validators.required],
    activityFullDescription: new FormControl,
  });

  createNewActivitySettings = this.formBuilder.group({
    topPickCtrl: [false, Validators.required],
    durationCtrl: ['', Validators.required],
    sellOutCtrl: [false, Validators.required],
    languageCtrl: ['', Validators.required],
    numberOfSlots: [0, Validators.required],
    timeOfDayCtrl: ['', Validators.required],
  });

  createNewActivityTimeDates = this.formBuilder.group({
    timeOfDayCtrl: [[], Validators.required],
    numberOfSlots: [0, Validators.required],
  });

  createNewActivityCore = this.formBuilder.group({
    pricePerPerson: [0, Validators.required],
    discountPricePercentage: [0, Validators.required],
    currencyCtrl: ['', Validators.required],
    sumbitActivityData: new FormControl({disabled: true}),
  });

  createNewActivityPictures = this.formBuilder.group({
    pictureFileDrop: new FormControl
  });


  ngOnInit() {
    // TODO: Load activity types with Amplify Gen 2
    this.mainActivityOptions = ['Snorkeling', 'Diving', 'Boat Tours', 'Bus Tours', 'Beach Tours'];
  }
  
  createActivity(){
    // TODO: Implement activity creation with Amplify Gen 2
    console.log('Activity creation form:', {
      about: this.createNewActivityAbout.value,
      settings: this.createNewActivitySettings.value,
      core: this.createNewActivityCore.value
    });
  }

  saveDates(activityId: string){
    // TODO: Implement date saving with Amplify Gen 2
    console.log('Saving dates for activity:', activityId);
  }

  convertDateStructure(ngbDate: NgbDateStruct) {
    const jsDate = new Date(ngbDate.year, ngbDate.month-1, ngbDate.day);
    return jsDate;
  }

  addPictures(activityId: string){
    // TODO: Implement picture upload with Amplify Gen 2
    console.log('Uploading pictures for activity:', activityId);
  }

  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
  */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 0.00) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  modelUnavailable?: NgbDateStruct;
  modelListUnavailable: NgbDateStruct[] = [];

  Unavailable_isSelected = (date?: NgbDate) => {
    return this.modelListUnavailable.indexOf(date) >= 0;
  };

  Unavailable_selectOne(date) {
    if (this.modelListUnavailable.indexOf(date) >= 0) {
      this.modelListUnavailable = this.modelListUnavailable.filter(function (ele) {
        return ele != date;
      });
    } else {
      this.modelListUnavailable.push(date);
    }
  }

  isDisabled = (date: NgbDateStruct, current: {month: number, year: number})=> {
    return this.modelListUnavailable.find(x => NgbDate.from(x).equals(date))? true: false;
  }

  modelAvailable?: NgbDateStruct;
  modelListAvailable: NgbDateStruct[] = [];

  Available_isSelected = (date?: NgbDate) => {
    return this.modelListAvailable.indexOf(date) >= 0;
  };

  Available_selectOne(date) {
    if (this.modelListAvailable.indexOf(date) >= 0) {
      this.modelListAvailable = this.modelListAvailable.filter(function (ele) {
        return ele != date;
      });
    } else {
      this.modelListAvailable.push(date);
    }
  }

}
